// extracted by mini-css-extract-plugin
module.exports = {"container":"RadioBox_container__c8JAp","input":"RadioBox_input__Op9CB","label":"RadioBox_label__tPDjO","icon":"RadioBox_icon__Zqqnh"};